<template>
    <span>
        <a class="list__tile list__tile__avatar list__tile--link list__tile--avatar">
            <div class="list__tile__avatar">
                <div class="avatar" style="height: 36px; width: 36px;">
                    <elv-avatar-icon :avatar="viewAsPlayer.avatar" width="32"/>
                </div>
            </div>

            <div style="font-family: Lato; line-height: 15px;">
                <div class="" style="font-size:85%">{{viewAsPlayer.username}}</div>
                <div class="list__tile__sub-title" style="font-size:65%; ">{{viewAsPlayer.serverName}}</div>
            </div>
        </a>
    </span>
</template>

<script>
    import ElvAvatarIcon from "./ElvAvatarIcon"

    export default {
        components: {ElvAvatarIcon},
        name: "elv-view-as-player",
        props: { viewAsPlayer: {required:true} },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ElvViewAsPlayer.vue